import {
  getFinalLiterConversion,
  getFinalCubicYardConversion,
  getFinalCubicMileConversion,
  getFinalCubicMeterConversion,
  getFinalCubicInchConversion,
  getFinalCubicFootConversion
} from "./VolumeConversionTracker";

function getConversion(val, conType) {
  let result = "";
  switch (conType.slice(0, 2)) {
    case "lt":
      result = getFinalLiterConversion(val, conType);
      break;
    case "yd":
      result = getFinalCubicYardConversion(val, conType);
      break;
    case "mi":
      result = getFinalCubicMileConversion(val, conType);
      break;
    case "mt":
      result = getFinalCubicMeterConversion(val, conType);
      break;
    case "in":
      result = getFinalCubicInchConversion(val, conType);
      break;
    case "ft":
      result = getFinalCubicFootConversion(val, conType);
      break;
    default:
      result = "";
  }

  return result;
}

export { getConversion };
